import React from 'react';
import { ResourceErrorData } from 'new/elements/support/detailTabs/ResourceErrorData';
import { RESOURCE_TYPE_DATA_SET } from 'js/constants/resourceTypes';

interface ErrorDataTabProps {
  dataset: {
    id: number;
    [key: string]: any;
  };
}

export const ErrorDataTab = ({ dataset }: ErrorDataTabProps) => {
  return <ResourceErrorData data={dataset} resourceType={RESOURCE_TYPE_DATA_SET} />;
};
